import { render, staticRenderFns } from "./CouponModel.vue?vue&type=template&id=6548e942&scoped=true"
import script from "./CouponModel.vue?vue&type=script&lang=js"
export * from "./CouponModel.vue?vue&type=script&lang=js"
import style0 from "./CouponModel.vue?vue&type=style&index=0&id=6548e942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6548e942",
  null
  
)

export default component.exports